const nav = document.querySelector(".product-board-nav");
const trigger = document.querySelector(".mobile-trigger");

if(nav && trigger){
    trigger.addEventListener("click", function () {
        nav.classList.toggle("open");
    });
}


/** Light On Feature */
class LightOnToggle {
  constructor(container) {
    this.container = container;
    this.button = container.querySelector('.light-toggle__button');
    this.buttonLabel = container.querySelector('.light-toggle__label');
    this.productGrid = document.querySelector('section.section.section-product-landing');
    this.isActive = false;
    this.isInTransition = false;
    this.images = [];

    this.init();
  }

  init() {
    if (!this.button || !this.productGrid) return;

    this.images = Array.from(
      this.productGrid.querySelectorAll('.image.image-cover[data-light-on]')
    ).map((img) => ({
      el: img,
      defaultBg: img.getAttribute('data-bg'),
      lightOnBg: img.getAttribute('data-light-on').replace(/^url\(["']?/, '').replace(/["']?\)$/, '')
    }));

    this.button.addEventListener('click', () => this.toggle());
  }

  toggle() {
    if (this.isInTransition) return;

    this.isInTransition = true;
    this.isActive = !this.isActive;

    this.container.classList.toggle('is-active', this.isActive);
    this.button.setAttribute('aria-pressed', this.isActive ? 'true' : 'false');
    this.buttonLabel.innerText = this.isActive ? 'Lights ON' : 'Lights OFF';

    this.images.forEach((item) => {
      var nextBg = this.isActive ? item.lightOnBg : item.defaultBg;

      item.el.style.backgroundImage = 'url(' + nextBg + ')';
      item.el.setAttribute('data-bg', nextBg);
    });

    setTimeout(() => {
      this.isInTransition = false;
    }, 300);
  }
}

document.querySelectorAll('[data-toggle]').forEach((toggleEl) => {
  new LightOnToggle(toggleEl);
});
document.addEventListener('DOMContentLoaded', function () {
  var announcementBar = document.querySelector('.announcement-bar');
  var announcementClose = document.querySelector('.announcement-bar-close');
  var storageKey = 'announcementBarClosedThisSession';

  if (!announcementBar) return;

  if (sessionStorage.getItem(storageKey) === 'true') {
    announcementBar.style.display = 'none';
    document.body.classList.remove('is-announcement-bar');
    document.body.classList.remove('announcement-bar-scrolled');
  }

  if (announcementClose) {
    announcementClose.addEventListener('click', function () {
      sessionStorage.setItem(storageKey, 'true');

      announcementBar.style.display = 'none';
      document.body.classList.remove('is-announcement-bar');
      document.body.classList.remove('announcement-bar-scrolled');
    });
  }
});
document.addEventListener('change', function (event) {
  var input = event.target;

  if (!input.matches('.product-form input[type="radio"][name="id"]')) return;

  var selectedVariantId = input.value;

  document.querySelectorAll('.display-for-variant').forEach(function (block) {
    if (block.getAttribute('data-variant-id') === selectedVariantId) {
      block.classList.add('show');
      block.classList.remove('hide');
    } else {
      block.classList.remove('show');
    }
  });

  var enquireButton = document.getElementById('enquire_btn');
  var enquire = document.getElementById('enquire');

  if (enquireButton) {
    enquireButton.classList.remove('active');
    enquireButton.checked = false;
  }

  if (enquire) {
    enquire.classList.remove('active');
  }
});
document.addEventListener('DOMContentLoaded', function () {
  var preloadedProductCardImages = Object.create(null);

  function preloadProductCardImage(url) {
    if (!url) return null;

    if (preloadedProductCardImages[url]) {
      return preloadedProductCardImages[url];
    }

    var preload = new Image();
    preload.src = url;
    preloadedProductCardImages[url] = preload;
    return preload;
  }

  function preloadProductCardImages(urls) {
    urls.forEach(function (url) {
      preloadProductCardImage(url);
    });
  }

  function whenProductCardImageReady(url, callback) {
    var preload = preloadProductCardImage(url);

    if (!preload) return;

    if (preload.complete) {
      callback();
      return;
    }

    preload.onload = callback;
  }

  document.querySelectorAll('.product-card-gallery').forEach(function (gallery) {
    var image = gallery.querySelector('.image.image-cover');
    var hoverImage = gallery.querySelector('.image-hover');
    var prev = gallery.querySelector('.product-card-gallery__arrow--prev');
    var next = gallery.querySelector('.product-card-gallery__arrow--next');
    var images = [];
    var hoverImageUrl = hoverImage ? hoverImage.getAttribute('data-bg') : null;
    var touchStartX = null;
    var didSwipe = false;

    try {
      images = JSON.parse(gallery.getAttribute('data-gallery-images') || '[]');
    } catch (error) {
      images = [];
    }

    if (hoverImageUrl) {
      preloadProductCardImages([hoverImageUrl]);
    }

    if (!image || images.length < 2) return;

    preloadProductCardImages(images);

    function setImage(index) {
      var safeIndex = (index + images.length) % images.length;
      var nextImage = images[safeIndex];

      whenProductCardImageReady(nextImage, function () {
        gallery.setAttribute('data-gallery-index', safeIndex);
        image.removeAttribute('data-bg');
        image.style.backgroundImage = 'url(' + nextImage + ')';
        image.classList.add('loaded');
      });
    }

    function move(direction) {
      var current = parseInt(gallery.getAttribute('data-gallery-index') || '0', 10);
      gallery.classList.add('is-gallery-active');
      setImage(current + direction);
    }

    if (prev) {
      prev.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        move(-1);
      });
    }

    if (next) {
      next.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        move(1);
      });
    }

    if (window.matchMedia('(hover: hover) and (min-width: 769px)').matches) {
      gallery.addEventListener('mouseleave', function () {
        gallery.classList.remove('is-gallery-active');
        setImage(0);
      });
    }

    gallery.addEventListener('touchstart', function (event) {
      touchStartX = event.changedTouches[0].clientX;
      didSwipe = false;
    }, { passive: true });

    gallery.addEventListener('touchend', function (event) {
      if (touchStartX === null) return;

      var deltaX = event.changedTouches[0].clientX - touchStartX;
      touchStartX = null;

      if (Math.abs(deltaX) < 22) return;

      didSwipe = true;
      move(deltaX < 0 ? 1 : -1);
    }, { passive: true });

    gallery.addEventListener('click', function (event) {
      if (!didSwipe) return;

      event.preventDefault();
      event.stopPropagation();
      didSwipe = false;
    }, true);
  });
});
/* ===== CreativeFold — Enquire -> Shopify Forms modal (Form 1054979, shadow DOM embed) ===== */
(function () {
  var modal, panel, moved = false;
  function embed(){ return document.querySelector('shopify-forms-embed'); }
  function productValue(){
    var btn = document.getElementById('enquire');
    var title = btn ? (btn.getAttribute('data-product-title') || '') : '';
    var sizeEl = document.querySelector('.product-variant-radios input:checked + label');
    var size = sizeEl ? sizeEl.textContent.trim() : '';
    return (size && !/one size|default/i.test(size)) ? (title + ' – ' + size) : title;
  }
  function prefill(){
    var e = embed(); if (!e || !e.shadowRoot) return;
    var lab = [].slice.call(e.shadowRoot.querySelectorAll('label')).find(function(l){ return /product/i.test(l.textContent); });
    var input = lab && (lab.control || (lab.parentElement && lab.parentElement.querySelector('input,textarea')));
    if (input) {
      input.value = productValue();
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  function buildModal(){
    modal = document.createElement('div');
    modal.className = 'cf-modal';
    modal.setAttribute('hidden', '');
    modal.innerHTML = '<div class="cf-modal__panel" role="dialog" aria-modal="true" aria-label="Product enquiry">' +
      '<button type="button" class="cf-modal__close" aria-label="Close">×</button>' +
      '<div class="cf-modal__slot"></div></div>';
    document.body.appendChild(modal);
    panel = modal.querySelector('.cf-modal__slot');
    modal.addEventListener('click', function(e){ if (e.target === modal || (e.target.closest && e.target.closest('.cf-modal__close'))) close(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && modal && !modal.hasAttribute('hidden')) close(); });
  }
  function styleEmbedTitle(e){
    try {
      var sr = e && e.shadowRoot;
      if (!sr || sr.querySelector('style[data-cf-title-font]')) return;
      var st = document.createElement('style');
      st.setAttribute('data-cf-title-font', '1');
      /* restyle the form's heading + submit button to match the theme (din_condensedbold) */
      st.textContent = 'h1,h2,h3,h4{font-family:"din_condensedbold","Arial",sans-serif !important;text-transform:uppercase;letter-spacing:normal}'
        + ' button[type="submit"],input[type="submit"],[type="submit"]{font-family:"din_condensedbold","Arial",sans-serif !important;text-transform:uppercase !important;letter-spacing:.04em !important}';
      sr.appendChild(st);
    } catch (err) {}
  }
  function open(){
    var e = embed();
    if (!e) { window.location.href = '/pages/contact?source=product-enquiry'; return; }
    if (!modal) buildModal();
    if (!moved) { panel.appendChild(e); e.style.display = ''; moved = true; }
    styleEmbedTitle(e); setTimeout(function(){ styleEmbedTitle(e); }, 300);
    modal.removeAttribute('hidden');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(prefill, 80); setTimeout(prefill, 500);
  }
  function close(){ if (!modal) return; modal.setAttribute('hidden', ''); document.documentElement.style.overflow = ''; }
  document.addEventListener('click', function(e){
    var t = e.target.closest && e.target.closest('#enquire');
    if (t) { e.preventDefault(); open(); }
  });
  var tries = 0;
  (function init(){
    var e = embed();
    if (e) { var sec = e.closest('.shopify-section') || e.parentElement; if (sec) sec.classList.add('cf-enquiry-hidden'); }
    else if (tries++ < 30) { setTimeout(init, 300); }
  })();
})();

/* ===== CreativeFold — Desktop gallery thumbnail swap ===== */
(function () {
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest && e.target.closest('.cf-thumb');
    if (!thumb) return;
    e.preventDefault();
    var g = thumb.closest('.cf-gallery');
    var main = g && g.querySelector('.cf-gallery__img');
    if (!main) return;
    if (thumb.dataset.full) main.src = thumb.dataset.full;
    if (thumb.dataset.w) main.setAttribute('width', thumb.dataset.w);
    if (thumb.dataset.h) main.setAttribute('height', thumb.dataset.h);
    if (thumb.dataset.zoom) main.setAttribute('data-zoom-src', thumb.dataset.zoom);
    main.setAttribute('data-image-index', thumb.dataset.index || '0');
    main.setAttribute('data-zoom-orientation', thumb.dataset.orientation || 'portrait');
    [].forEach.call(g.querySelectorAll('.cf-thumb'), function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });
})();

/* ===== CreativeFold — Mobile gallery thumbnail strip synced to swiper ===== */
(function () {
  function wire(scope) {
    var swiperEl = scope.querySelector('.productswiper');
    var strip = scope.querySelector('.cf-mthumbs');
    if (!swiperEl || !strip) return true; /* nothing to wire here */
    var sw = swiperEl.swiper;
    if (!sw) return false; /* swiper not initialised yet */
    var btns = [].slice.call(strip.querySelectorAll('.cf-mthumb'));
    function setActive(i) {
      btns.forEach(function (b, idx) { b.classList.toggle('is-active', idx === i); });
      if (btns[i]) btns[i].scrollIntoView({ inline: 'nearest', block: 'nearest' });
    }
    strip.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.cf-mthumb');
      if (!b) return;
      var i = parseInt(b.getAttribute('data-index'), 10) || 0;
      if (sw.params && sw.params.loop && sw.slideToLoop) sw.slideToLoop(i); else sw.slideTo(i);
    });
    sw.on('slideChange', function () { setActive(typeof sw.realIndex === 'number' ? sw.realIndex : sw.activeIndex); });
    setActive(sw.realIndex || 0);
    return true;
  }
  var tries = 0;
  (function init() {
    var scopes = [].slice.call(document.querySelectorAll('.productswiper-wrap .display-for-variant'));
    var pending = false;
    scopes.forEach(function (s) { if (!s.__cfThumbsWired) { if (wire(s)) s.__cfThumbsWired = true; else pending = true; } });
    if (pending && tries++ < 40) setTimeout(init, 300);
  })();
})();

/* ===== CreativeFold — Footer Klaviyo signup: set email placeholder (form renders async) ===== */
(function () {
  var TEXT = 'Enter your email address';
  function apply() {
    var form = document.querySelector('.klaviyo-form-V4Xt2f');
    if (!form) return false;
    var input = form.querySelector('input[type="email"], input[type="text"]:not([type="hidden"])');
    if (input && input.placeholder !== TEXT) input.setAttribute('placeholder', TEXT);
    return !!input;
  }
  if (apply()) return;
  var tries = 0;
  var iv = setInterval(function () { if (apply() || tries++ > 40) clearInterval(iv); }, 300);
  // Klaviyo can re-render on interaction — keep the placeholder set
  var host = document.querySelector('.klaviyo-form-V4Xt2f');
  if (host && window.MutationObserver) { new MutationObserver(apply).observe(host, { childList: true, subtree: true }); }
})();
